export const colors = {
  DNGBlue: '#313c97',
  midnight: '#23233f',
  discoverOrange: '#ec6b29',
};
